import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import withDevicesForm from 'hocs/extends/withDevicesForm'
import Accordion from 'components/accordions/Accordion'
import { refElements } from '../../../renderer/utils/elementUtils'
import ImageSettings from '../../elementForms/image/ImageSettings'
import CardSettings from '../../elementForms/card/CardSettings'

const DevicesImageSettings = withDevicesForm(ImageSettings)
const DevicesCardSettings = withDevicesForm(CardSettings)

const EffectSwitcher = ({
  refElement,
  value,
  value: {
    defaultStyles = {},
    deviceStyles = {},
    defaultSettings = {},
    deviceSettings = {},
  },
  onChange,
}) => {
  const handleUpdate = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  const renderForms = () => {
    switch (refElement) {
      case refElements.IMAGE:
        return (
          <Accordion
            accordionProps={{ isLargePadded: true }}
            defaultActiveItems={['default']}
          >
            <ImageSettings
              label="Default Setting"
              subValue="default"
              valueStyles={defaultStyles}
              valueSettings={defaultSettings}
              onChangeSettings={(val) => handleUpdate(val, 'defaultSettings')}
              onChangeStyle={(val) => handleUpdate(val, 'defaultStyles')}
            />
            <DevicesImageSettings
              label="Override setting in each device"
              subValue="device"
              valueSettings={deviceSettings}
              valueStyles={deviceStyles}
              onChangeSettings={(val) => handleUpdate(val, 'deviceSettings')}
              onChangeStyle={(val) => handleUpdate(val, 'deviceStyles')}
            />
          </Accordion>
        )
      case refElements.CARD:
        return (
          <Accordion
            accordionProps={{ isLargePadded: true }}
            defaultActiveItems={['default']}
          >
            <CardSettings
              label="Default Setting"
              subValue="default"
              value={defaultSettings}
              onChange={(val) => handleUpdate(val, 'defaultSettings')}
            />
            <DevicesCardSettings
              label="Override setting in each device"
              subValue="device"
              value={deviceSettings}
              onChange={(val) => handleUpdate(val, 'deviceSettings')}
            />
          </Accordion>
        )
      default:
        return <div>unedited settings</div>
    }
  }

  return (
    <div>
      {renderForms()}
    </div>
  )
}

EffectSwitcher.propTypes = {}
EffectSwitcher.defaultProps = {}

export default EffectSwitcher



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/EffectSwitcher.js